export default __webpack_public_path__ + "static/media/product-details-4.a1e3a033.jpg";